import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { openFulfillmentGuard } from './core/guards/fulfillment-route.guard';
import { notInPreviewGuard, PREVIEW_SCREENS } from './core/guards/preview-screen.guard';

// Screens are lazy-loaded so each lands in its own chunk (smaller initial bundle).
const screens: Routes = [
  { path: 'home', loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent) },
  { path: 'menu', loadComponent: () => import('./features/menu/menu.component').then((m) => m.MenuComponent) },
  { path: 'search', loadComponent: () => import('./features/search/search.component').then((m) => m.SearchComponent) },
  { path: 'cart', loadComponent: () => import('./features/cart/cart.component').then((m) => m.CartComponent) },
  { path: 'checkout', loadComponent: () => import('./features/checkout/checkout.component').then((m) => m.CheckoutComponent) },
  { path: 'tracking', loadComponent: () => import('./features/tracking/tracking.component').then((m) => m.TrackingComponent) },
  { path: 'feedback/:id', loadComponent: () => import('./features/feedback/feedback.component').then((m) => m.FeedbackComponent) },
  { path: 'orders', loadComponent: () => import('./features/orders/orders.component').then((m) => m.OrdersComponent) },
  { path: 'orders/:no', loadComponent: () => import('./features/order-details/order-details.component').then((m) => m.OrderDetailsComponent) },
  { path: 'account', loadComponent: () => import('./features/account/account.component').then((m) => m.AccountComponent) },
  { path: 'reservation', loadComponent: () => import('./features/reservation/reservation.component').then((m) => m.ReservationComponent) },
  { path: 'reservations', loadComponent: () => import('./features/reservations/reservations.component').then((m) => m.ReservationsComponent) },
  { path: 'reservations/:id', loadComponent: () => import('./features/reservation-detail/reservation-detail.component').then((m) => m.ReservationDetailComponent) },
  { path: 'branches', loadComponent: () => import('./features/branches/branches.component').then((m) => m.BranchesComponent) },
  { path: 'dinein', loadComponent: () => import('./features/dinein/dinein.component').then((m) => m.DineinComponent) },
  { path: 'dinein/:token', loadComponent: () => import('./features/dinein/dinein.component').then((m) => m.DineinComponent) },
  // Special route: opens the FulfillmentSheet overlay then restores the prior screen (guard cancels navigation).
  { path: 'fulfillment', canActivate: [openFulfillmentGuard], children: [] },
];

// The admin live preview is read-only: every screen but Home and Menu is
// unmatched there, so it falls through to the `**` → home redirect below.
const routes: Routes = [
  ...screens.map((route) => PREVIEW_SCREENS.includes(route.path ?? '')
    ? route
    : { ...route, canMatch: [...(route.canMatch ?? []), notInPreviewGuard] }),
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
